import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_REPORTINGTAGCATEGORY_LOAD,
    ACTION_REPORTINGTAGCATEGORY_LOAD_BY_ID,
    ACTION_REPORTINGTAGCATEGORY_LOAD_FAILURE,
    ACTION_REPORTINGTAGCATEGORY_LOAD_SUCCESS,

    ACTION_REPORTINGTAGCATEGORY_SAVE,
    ACTION_REPORTINGTAGCATEGORY_SAVE_SUCCESS,
    ACTION_REPORTINGTAGCATEGORY_SAVE_FAILURE,

    ACTION_REPORTINGTAGCATEGORY_CREATE,
    ACTION_REPORTINGTAGCATEGORY_CREATE_SUCCESS,
    ACTION_REPORTINGTAGCATEGORY_CREATE_FAILURE,

    ACTION_REPORTINGTAGCATEGORY_CLEAR,
    ACTION_REPORTINGTAGCATEGORY_FILTER,

    ReportingTagCategoryAction
} from '../actions/reportingTagCategories';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IReportingTagCategoryState {
    formData: Dtos.ReportingTagCategory | Dtos.ReportingTagCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    formRoles: Dtos.RoleType[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.ReportingTagCategory[];
}

const initialState: IReportingTagCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    formRoles: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: IReportingTagCategoryState, isLoading: boolean): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IReportingTagCategoryState,
    formData: Dtos.ReportingTagCategory | Dtos.ReportingTagCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    formRoles: Dtos.RoleType[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        formRoles: {
            $set: formRoles
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IReportingTagCategoryState, formFilter: IFormFilter): IReportingTagCategoryState {

    const interests: Dtos.ReportingTagCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = interests ? interests.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IReportingTagCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IReportingTagCategoryState, responseStatus: Dtos.ResponseStatus): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IReportingTagCategoryState, propertiesToClear?: string[]): IReportingTagCategoryState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IReportingTagCategoryState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IReportingTagCategoryState, isSaving: boolean): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IReportingTagCategoryState,
    formData: Dtos.ReportingTagCategory | Dtos.ReportingTagCategory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IReportingTagCategoryState, responseStatus: Dtos.ResponseStatus): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IReportingTagCategoryState, isCreating: boolean): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IReportingTagCategoryState,
    formData: Dtos.ReportingTagCategory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    formRoles: Dtos.RoleType[],
    lookups: Dtos.Lookup[]
): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        formRoles: {
            $set: formRoles
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IReportingTagCategoryState, responseStatus: Dtos.ResponseStatus): IReportingTagCategoryState {
    const newState: IReportingTagCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

const ReportingTagCategoryReducer: Reducer<IReportingTagCategoryState> = (state: IReportingTagCategoryState = initialState, action: ReportingTagCategoryAction) => {
    switch (action.type) {
        case ACTION_REPORTINGTAGCATEGORY_LOAD:
        case ACTION_REPORTINGTAGCATEGORY_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_REPORTINGTAGCATEGORY_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.formRoles, action.lookups, action.responseStatus);
       case ACTION_REPORTINGTAGCATEGORY_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_REPORTINGTAGCATEGORY_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_REPORTINGTAGCATEGORY_SAVE:
            return saving(state, true);
        case ACTION_REPORTINGTAGCATEGORY_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_REPORTINGTAGCATEGORY_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_REPORTINGTAGCATEGORY_CREATE:
            return creating(state, true);
        case ACTION_REPORTINGTAGCATEGORY_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.formRoles, action.lookups);
        case ACTION_REPORTINGTAGCATEGORY_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_REPORTINGTAGCATEGORY_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default ReportingTagCategoryReducer;